import {ExternalUserEQuery} from '../../../e-queries/models/external-user-e-query';
import { dataMember, required } from 'santee-dcts';

export class SponsorEQuery extends ExternalUserEQuery {
    @dataMember()
    @required()
    public protocolId: number;

    @dataMember()
    @required()
    public siteId: number;
}
